import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fr_skeleton = _resolveComponent("fr-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-100 flex py-4", { 'justify-end': _ctx.sender }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex w-4/6 md:w-2/5 items-center justify-start jst", { 'flex-row-reverse': _ctx.sender }])
    }, [
      _createVNode(_component_fr_skeleton, {
        circle: "",
        width: "2.5rem",
        class: _normalizeClass(["flex-shrink-0", [_ctx.sender ? 'ml-2' : 'mr-2']])
      }, null, 8, ["class"]),
      _createVNode(_component_fr_skeleton, {
        class: "w-1/3",
        height: "2.5rem"
      })
    ], 2)
  ], 2))
}